import { FC } from 'react';

// ========================= 组件 =========================
import IconFont from '@/components/iconfont';

// ========================= 数据交互 =========================

// ========================= 全局数据 =========================

// ========================= 常量 =========================

// ========================= 工具 =========================

// ========================= 样式 =========================
import styles from './index.module.css';

// ========================= 变量 =========================

// ========================= 类型 =========================

interface Item {
    id: number;
    [key: string]: any;
}

interface VideoPreviewProps {
    items: Item[];
    visible?: boolean;
    videoIndex?: number;
    title?: string;
    onClose?: () => void;
    onChange?: (index: number, action: 'pre' | 'next') => void;
}

const VideoPreview: FC<VideoPreviewProps> = ({ items, title, visible, videoIndex = 0, onClose, onChange }) => {
    if (!visible) {
        return null; // 如果不可见，直接返回null
    }
    return (
        <section
            className={styles.video_popups}
            id="video_popups"
            onClick={(e: React.MouseEvent<HTMLElement, MouseEvent>) => {
                const id = (e.target as HTMLElement).id as string;
                if (id === "video_popups") {
                    onClose && onClose()
                }
            }}
        >
            <div className={styles.video_popups_wrapper}>
                <h3 className={styles.video_popups_title}>
                    {title}
                </h3>
                <section className={styles.video_content}>
                    <IconFont
                        type="icon-houtui"
                        role="button"
                        className={styles.images_popups_Prev}
                        onClick={() => onChange && onChange(videoIndex, 'pre')}
                    />

                    <video
                        className={styles.video}
                        src={items[videoIndex]?.detailsUrl}
                        poster={items[videoIndex]?.videoCoverUrl}
                        controls
                        controlsList="nodownload"
                        autoPlay
                        preload="auto"
                    ></video>

                    <IconFont
                        type="icon-qianjin"
                        role="button"
                        className={styles.images_popups_Next}
                        onClick={() => onChange && onChange(videoIndex, 'next')}
                    />
                </section>
                <h4 className={styles.video_popups_subtitle}>
                    {items[videoIndex]?.title}
                </h4>
                <p className={styles.video_popups_desc}>
                    {items[videoIndex]?.abstractInfo}
                </p>
            </div>
        </section>
    );
}
export default VideoPreview;